import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

const PrivateRoute = () => {
  const [authState, setAuthState] = useState('loading');

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await getCurrentUser();
        console.log('Authenticated user:', user);
        setAuthState('authenticated');
      } catch (error) {
        console.log('User not authenticated:', error);
        setAuthState('unauthenticated');
      }
    };

    checkUser();
  }, []);

  if (authState === 'loading') return <div>Loading...</div>;
  if (authState === 'unauthenticated') return <Navigate to="/" replace />;
  return <Outlet />;
};

export default PrivateRoute;
